<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="annualReviews"
            hide-default-footer
            disable-pagination
            mobile-breakpoint="0"
            @click:row="editEntry($event)"
            style="cursor: pointer"
        >
            <template v-slot:[`item.date`]="{ item }">
                <div class="d-flex align-center py-2">
                    {{ moment(item.date).tz("UTC").format("MM/DD/YYYY") }}
                </div>
            </template>
            <template v-slot:[`item.reviewer`]="{ item }">
                <div class="d-flex align-center py-2">
                    {{ item.reviewer.name }}
                </div>
            </template>
            <template v-slot:[`item.content`]="{ item }">
                <div class="d-flex align-center py-2">
                    {{ `${item.content.substring(0, 50)}...` }}
                </div>
            </template>
        </v-data-table>
        <SoliForm
            v-if="dialog"
            :title="`${form.id ? 'Edit' : 'Create'} Review`"
            text="Save"
            icon="save"
            ref="form"
            persistent
            large
            :loadingProp="form.processing"
            :saveChanges="editing"
            @submit="submit()"
            @reset="reset()"
            ><template #body>
                <SoliDate
                    v-model="form.date"
                    validate-on-blur
                    :rules="[
                        (val) =>
                            (val || '').length > 0 || 'This field is required',
                    ]"
                    :error="errors.date"
                    :max="dateMax()" />
                <SoliStudents
                    label="Reviewer"
                    onDemand
                    v-model="form.user"
                    :error="errors.user_id"
                    :key="form.user?.id"
                    autocomplete />
                <v-textarea
                    ref="notes"
                    outlined
                    dense
                    class="soli-round"
                    label="Notes"
                    v-model="form.content"
                    :rules="contentRules"
                    :error-messages="errors.content"
                ></v-textarea
            ></template>
            <template v-slot:cancelBtn="attrs">
                <SoliBtn
                    v-if="!editing && form.id"
                    text="Delete"
                    icon="delete"
                    v-bind="attrs"
                    class="mt-3"
                    color="soli-status-red"
                    @click="confirmDelete = form.id"
                ></SoliBtn> </template
        ></SoliForm>
        <SoliChoice
            v-if="confirmDelete"
            title="Are you sure?"
            subtitle="This review will be deleted."
            button1="Delete"
            button2="Nevermind"
            @option1="deleteEntry(confirmDelete)"
            @reset="closeModal(() => (confirmDelete = null))"
        ></SoliChoice>
    </div>
</template>

<script>
export default {
    props: ["teacher", "annualReviews", "errors"],
    data() {
        return {
            dialog: false,
            editing: false,
            validated: false,
            confirmDelete: null,
            form: this.$inertia.form({
                date: moment().tz("UTC").format("MM/DD/YYYY"),
                content: "",
                user: this.$page.props.auth.user,
                id: null,
            }),
            formCopy: null,
            headers: [
                {
                    text: "Date",
                    align: "start",
                    sortable: true,
                    value: "date",
                },
                {
                    text: "Reviewer",
                    align: "start",
                    sortable: true,
                    value: "reviewer",
                },
                {
                    text: "Content",
                    align: "start",
                    sortable: true,
                    value: "content",
                    width: "50%",
                },
            ],
            contentRules: [
                (v) => !!v || "This field is required",
                (v) => (v || "").length <= 1000 || "Character limit reached",
                (v) => (v && !!v.trim()) || "This field is required",
            ],
        };
    },
    computed: {
        saveChanges() {
            return !!(!this.editing && this.form.id);
        },
    },
    methods: {
        editEntry(entry) {
            this.dialog = true;
            this.form.id = entry.id;
            this.form.date = moment(entry.date).tz("UTC").format("MM/DD/YYYY");
            this.form.content = entry.content;
            this.form.user = entry.reviewer;

            this.formCopy = JSON.stringify(this.form);
        },
        deleteEntry(entry) {
            this.$inertia.delete(`/teacher-review/${entry}`, {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$emit("success");
                    this.reset();
                },
                onError: (errors) => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(errors)
                    );
                },
            });
        },
        submit() {
            if (!this.$refs.form.$refs.form.validate()) return;

            this.form.transform((data) => ({
                user_id: data.user.id,
                location_user_id: this.teacher.locations.find(
                    (e) =>
                        e.id == this.$page.props.auth.user.selected_location.id
                ).pivot.id,
                date: data.date,
                content: data.content,
            }));

            let options = {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.$emit("success");
                    this.reset();
                },
                onError: () => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(this.errors)
                    );
                },
            };

            if (this.form.id) {
                this.form.put(`/teacher-review/${this.form.id}`, options);
            } else {
                this.form.post("/teacher-review", options);
            }
        },
        reset() {
            this.$refs.form.reset();

            setTimeout(() => {
                this.form.reset();
                this.form.user = this.$page.props.auth.user;
                this.form.content = "";
                this.formCopy = JSON.stringify(this.form);
                this.confirmDelete = null;
                this.editing = false;
                this.dialog = false;
            }, 300);
        },
        dateMax() {
            return moment().format("YYYY-MM-DD");
        },
    },
    mounted() {
        this.formCopy = JSON.stringify(this.form);
    },
    watch: {
        form: {
            handler: function (val) {
                if (!val) return;
                let copy = JSON.parse(this.formCopy);
                if (
                    val.date == copy.date &&
                    val.user?.id == copy.user?.id &&
                    val.content == copy.content
                ) {
                    this.editing = false;
                } else {
                    this.editing = true;
                }
            },
            deep: true,
        },
    },
};
</script>
